const baseUrl = process.env.PUBLIC_URL || '';

const APP_ROUTES = {
  LOGIN: `${baseUrl}/`,
  APPOINMENTS: `${baseUrl}/appointments`,
  DASHBOARD: `${baseUrl}/dashboard`,
  ANALYTICS: `${baseUrl}/analytics`,
  PATIENTLIST: `${baseUrl}/patientlist`,
  PAYMENTS: `${baseUrl}/payments`,
  BILLINGREPORT: `${baseUrl}/billingReport`,
  ORDERREPORT: `${baseUrl}/orderReport`,
  SETTINGS: `${baseUrl}/settings`,
  ACCOUNTS: `${baseUrl}/accounts`,
  NEWACCOUNT: `${baseUrl}/newaccount`,
  PRACTICEADMIN: `${baseUrl}/practiceadmin`,
  CHANGEPASSWORD: `${baseUrl}/changePassword`,
  CLINIC: `${baseUrl}/clinics`,
  USER: `${baseUrl}/users`,
  NEWUSER: `${baseUrl}/userForm`,
  EDITENROLLUSER: `${baseUrl}/editenrolluser`,
  NEWCLINIC: `${baseUrl}/newclinic`,
  FORGETPASSWORD: `${baseUrl}/forgetpassword`,
  PRECONSULTATION: `${baseUrl}/preConsultation`,
  VIDEOCALL: `${baseUrl}/videocall`,
  ENROLLEDUSER: `${baseUrl}/enrolleduser`,
  PHARMACIES: `${baseUrl}/pharmacies`,
  ADDPHARMA: `${baseUrl}/newpharmauser`,
  ADDLAB: `${baseUrl}/newlabuser`,
  AUTHENTICATE: `${baseUrl}/authenticate`,
  PHONEPEPAYMENT: `${baseUrl}/phonepepayment/:transactionId`,
  SERVICEPAYMENT: `${baseUrl}/servicepayment/:transactionId`,
  NEWANALYTICS: `${baseUrl}/analytics`,
  PROCEDURE: `${baseUrl}/procedureList`,
  NOTIFICATION: `${baseUrl}/notification`,
  REFERRAL: `${baseUrl}/referral`,
  TEMPLATES: `${baseUrl}/templates`,
  SPECIALITYTEMPMAP: `${baseUrl}/speciality-template-mapping`,
  USERCLINICS: `${baseUrl}/userclinics`,
  PROCEDURALSERVICE: `${baseUrl}/proceduralservice`,
  INVOICE: `${baseUrl}/invoice`,
  BOOKAPPOINTMENT: `${baseUrl}/bookappointment`,
  DOCTORDETAILS: `${baseUrl}/doctordetails`,
  BOOKMEDICINES: `${baseUrl}/bookmedicine`,
  MEDICINEDETAILS: `${baseUrl}/medicinedetails`,
  MYCART: `${baseUrl}/cart`,
  LABTEST: `${baseUrl}/labtest`,
  TESTDETAILS: `${baseUrl}/testdetails`,
  PROCEDURAL: `${baseUrl}/procedural`,
  BOOKPROCEDURE: `${baseUrl}/bookprocedure`,
  ORDERHISTORY: `${baseUrl}/orderhistory`,
  VIRTUALCASH: `${baseUrl}/virtualcash`,
  USERTEMPLATES: `${baseUrl}/usertemplates`,
  DISCOUNT:`${baseUrl}/discount`,
  RPMVITALPARAMS:`${baseUrl}/vitalparams`,
  RPMTASKFREQUENCY:`${baseUrl}/taskfrequency`,
  DEVICESETUP:`${baseUrl}/devicesetup`,
  RPMBILLINGREPORT:`${baseUrl}/rpmbillingreport`,
  RPMDASHBOARD:`${baseUrl}/rpmdashboard`,
  RPMCLINICALNOTES:`${baseUrl}/rpmclinicalnotes`,
  RPMMEDICALHISTORY:`${baseUrl}/rpm-medicalhistory`,
  RPMMEDICALRECORDS:`${baseUrl}/medicalrecords`,
  RPMACTIVITYREPORT:`${baseUrl}/activityreport`,
  RPMPATIENTPALLETTE:`${baseUrl}/patient-pallette`,
  PATIENTCRITICAL:`${baseUrl}/patient-critical`,
  PATIENTABNORMAL:`${baseUrl}/patient-abnormal`,
  PATIENTNORMAL:`${baseUrl}/patient-normal`,
  LEADERBOARD:`${baseUrl}/leader_board`,
  MEDICALHISTORY:`${baseUrl}/medicalhistory`,
  PRESCRIPTIONS:`${baseUrl}/prescriptions`,
  REPORTS:`${baseUrl}/reports`,
  VITALS:`${baseUrl}/vitals`,
  MEDICAL:`${baseUrl}/medical`,
  EMERGENCYQR: `${baseUrl}/emergencyqr/:id`,
  MEMBERSHIP:`${baseUrl}/membership`,
  NEWMEMBERSHIP:`${baseUrl}/new-membership`,
  FAMILYMEMBERS:`${baseUrl}/familyMembers`,
  CONSENT:`${baseUrl}/consent`,
  PATIENTDEVICES:`${baseUrl}/patient-devices`,
  DOCTORENROLLMENTFORM:`${baseUrl}/doctor-enrollment-form`,
  RPMENROLLMENTFORM:`${baseUrl}/rpm-enrollment-form`,
  DIETPLAN:`${baseUrl}/dietplan`,
  DEMOREQUESTS:`${baseUrl}/demorequests`,
  BILLINGPAYMENTS:`${baseUrl}/billinglists`
};

export { APP_ROUTES };
